import React from 'react';
import PropTypes from 'prop-types';

import createStyle from 'shared-utils/src/createStyle';

import Grid from '../../../../Grid';
import GridItem from '../../../../GridItem';
import CheckboxField from '../../../../CheckboxField';
import Spinner from '../../../../Spinner';

import style, { mainCls } from './style';
import trackGTMEvents from 'shared-utils/src/trackGTMEvents/new';
import sleep from 'shared-utils/src/sleep';

const useStyles = createStyle(style);

const Footer = ({
  isMobile,
  auctionFilter,
  closeFn,
  saveFn,
  saving,
  goToUnregisteredPanel,
  isFromNotRegisteredUser,
}) => {
  const cls = useStyles();
  const toggleAuctionFilter = () => auctionFilter.setAuctionFilter(state => !state);

  const discardAndClose = () => {
    sleep(300).then(() => trackGTMEvents({
      category: 'FavouriteAndAlert',
      action: 'CloseAlertModal',
      position: 'Bottom_Button',
    }));
    closeFn();
  };

  const getButtonFooter = () => {
    if (isFromNotRegisteredUser) {
      return (
        <GridItem behavior="fixed">
          <Grid className={cls[`${mainCls}__btns`]} justify="space-between">
            <button
              type="button"
              className={`${cls[`${mainCls}__close`]} tp-w--m c-txt--f5 c-bg--w c-br--borderdark b--s b-r--m is-clickable`}
              onClick={discardAndClose}
            >
              Annulla
            </button>
            <button
              type="button"
              className={`${cls[`${mainCls}__save`]}${isMobile ? '' : ' ml--m'} tp-w--l c-txt--w c-bg--primary c-br--primary b--s b-r--m is-clickable`}
              onClick={goToUnregisteredPanel}
            >
              Salva ricerca
            </button>
          </Grid>
        </GridItem>
      )
    }
    return (
      <GridItem behavior="fixed">
        <Grid className={cls[`${mainCls}__btns`]} justify="space-between">
          <button
            type="button"
            className={`${cls[`${mainCls}__close`]} tp-w--m c-txt--f5 c-bg--w c-br--borderdark b--s b-r--m is-clickable`}
            onClick={discardAndClose}
          >
            Annulla
          </button>
          <button
            type="button"
            className={`${cls[`${mainCls}__save`]}${isMobile ? '' : ' ml--m'} tp-w--l c-txt--w c-bg--primary c-br--primary b--s b-r--m is-clickable`}
            onClick={saveFn}
          >
            {saving
              ? <Spinner className="tp-va--m mr--s" inline={false} color="w" />
              : 'Salva ricerca'
            }
          </button>
        </Grid>
      </GridItem>
    )
  }
  return (
    <>
      <Grid className={cls[mainCls]} direction="column">
        {auctionFilter.showAuctionCheckbox && (
          <GridItem behavior="fixed">
            <Grid className={cls[`${mainCls}__auct`]} justify={isMobile ? '' : 'flex-end'}>
              <CheckboxField
                gutters="m"
                color="secondary"
                checked={auctionFilter.value}
                onChange={toggleAuctionFilter}
              >
                <span className=" tp-s--m tp-w--m">Escludi immobili all’asta</span>
              </CheckboxField>
            </Grid>
          </GridItem>
        )}
        {getButtonFooter()}
      </Grid>
    </>
  )
};

export default Footer;

Footer.propTypes = {
  isMobile: PropTypes.bool,
  auctionFilter: PropTypes.instanceOf(Object),
  closeFn: PropTypes.func,
  saveFn: PropTypes.func,
  saving: PropTypes.bool,
};
Footer.defaultProps = {
  isMobile: true,
  auctionFilter: {},
  closeFn: () => { },
  saveFn: () => { },
  saving: false,
};